import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@store/root";

export const GRID_VIEW = 'grid';
export const LIST_VIEW = 'list';

type PreferencesState = {
  itemCount: number;
  defaultView: string;
  showNewUserModal: boolean;
  listViewNoImages: boolean;
};

const initialState = {
  itemCount: 50,
  defaultView: GRID_VIEW,
  showNewUserModal: true,
  listViewNoImages: false,
} as PreferencesState;

const preferencesSlice = createSlice({
  name: "preferences",
  initialState,
  reducers: {
    setItemCount(state, action: PayloadAction<number>) {
      state.itemCount = action.payload;
    },
    setDefaultView(state, action: PayloadAction<string>) {
      state.defaultView = action.payload;
    },
    setShowNewUserModal(state, action: PayloadAction<boolean>) {
      state.showNewUserModal = action.payload;
    },
    setListViewNoImages(state, action: PayloadAction<boolean>) {
      state.listViewNoImages = action.payload;
    },
  },
});

export const getShowListView = (state: RootState) => state.preferences.defaultView === LIST_VIEW; // Selector
export const getItemCount = (state: RootState) => state.preferences.itemCount; // Selector
export const getShowNewUserModal = (state: RootState) => state.preferences.showNewUserModal; // Selector
export const getListViewNoImages = (state: RootState) => state.preferences.listViewNoImages; // Selector
export const {
  setItemCount,
  setDefaultView,
  setShowNewUserModal ,
  setListViewNoImages,
} = preferencesSlice.actions; // Auto-generated action

export default preferencesSlice.reducer;
